import { Head, useHead } from "@unhead/react";

import { SEOHead } from "@/components/helpers/seo/SEOHead";
import { Box } from "@/components/layout/flexbox";
import { PublicFooter } from "@/components/nav/PublicFooter";
import { ExecNav } from "@/components/nav/PublicNav/ExecNav";
import { BrandsV2 } from "@/components/pieces/marketing/BrandsV2";
import { ExecUseCases } from "@/components/pieces/marketing/ExecUseCases";
import { PartnerTestimonials } from "@/components/pieces/marketing/PartnerTestimonials";

import { FeatureHero } from "./FeatureHero";
import { Impact } from "./Impact";
import { MainHero } from "./MainHero";
import { MissionBar } from "./MissionBar";
import { PlatformAreas } from "./PlatformAreas";

export function ExecHomePage() {
  useHead({
    bodyAttrs: { class: "public-site" },
  });
  return (
    <>
      <SEOHead
        title="Exec – AI-Powered Training for High-Performance Teams"
        description="Turn high-stakes conversations into consistent wins with realistic voice-based AI training."
        canonicalDomain="https://www.exec.com/"
        image="https://placement-pub.s3.us-east-2.amazonaws.com/exec-home-meta.jpg"
      />
      <Head>
        <style type="text/css">{`
          #root {
            overflow-x: hidden;
          }
        `}</style>
      </Head>
      <ExecNav />
      <Box backgroundColor="#FFF">
        <MainHero />
        <div className="hidden md:block">
          <FeatureHero />
        </div>
        <div className="bg-gray-200 md:bg-transparent">
          <BrandsV2
            opacity={1}
            backgroundColor="transparent"
            className="py-8 md:py-16"
          />
        </div>
        <div className="hidden md:block">
          <MissionBar />
          <ExecUseCases />
          <PartnerTestimonials
            partnerIds={[
              "phm",
              "axonius",
              "convene",
              "xencor",
              "eko",
              "cockroach",
            ]}
          />
        </div>
        <PlatformAreas />
        <div className="md:hidden">
          <PartnerTestimonials
            partnerIds={[
              "phm",
              "axonius",
              "convene",
              "xencor",
              "eko",
              "cockroach",
            ]}
          />
          <ExecUseCases />
        </div>
        <Impact />
        <PublicFooter />
      </Box>
    </>
  );
}
